module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZPhDYIwEIUPJ2CEjsAIuoGbuIIb6AawgSMwQkcoG+AG55FcY9O8GmyL/uElL00o3Me9a4l2/UvMfBHfxYa2khTv+a1Z3FFNScFWbBXgxI/qMAAx+vwadHemEqUgwb6HufjbA62UFrXiT9EwlWiBaAe+ExTdrSg6ADEgwr7oMEQQC2YycOnxBpAWvNNvCgHRZUG6ADKugBj6VtrJrEUGsF8O0UJHH1fiJ1wuJHVhnzFEllG8rJP41DTNRBVAVSGoqI8OyWbPBIDaYA6hRgb3aNdP9AItGu8i/z0BdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Edit_Pencil_01.png
// module id = Mgjd
// module chunks = 1